import {
  REGISTRATION_NUMBER_REGEX,
  TAX_IDENTIFICATION_REGEX,
} from "@zenith/data/constants";

export const setRegistrationNumberValidations = (
  registrationNumber: string
) => {
  const hasError = false;
  const message = "";

  if (registrationNumber === "") {
    return {
      hasError: true,
      message: "Registration Number is required",
    };
  }

  if (!REGISTRATION_NUMBER_REGEX.test(registrationNumber)) {
    return {
      hasError: true,
      message: "Registration Number not valid",
    };
  }

  return {
    hasError,
    message,
  };
};

export const setTaxIdentificationNumberValidations = (
  taxIdentificationNumber: string
) => {
  const hasError = false;
  const message = "";

  if (taxIdentificationNumber === "") {
    return {
      hasError: true,
      message: "Tax Identification Number is required",
    };
  }

  if (!TAX_IDENTIFICATION_REGEX.test(taxIdentificationNumber)) {
    return {
      hasError: true,
      message: "Tax Identification Number not valid",
    };
  }

  return {
    hasError,
    message,
  };
};
